import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import { i18n } from './plugins/i18n'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import BootstrapVueNext from 'bootstrap-vue-next'

import VueCookies from 'vue3-cookies'

import VuePlyr from '@skjnldsv/vue-plyr'
import '@skjnldsv/vue-plyr/dist/vue-plyr.css'

import './assets/styles/style.css'
import './assets/styles/portal.css'
import {v1 as uuidv1, v4 as uuidv4} from 'uuid'

// Global mixin
import titleMixin from './mixins/titleMixin'
import { install } from "vue3-recaptcha-v2"

const app = createApp(App)

app.use(router)
app.use(store)
app.use(i18n)
app.use(BootstrapVueNext)
app.use(VueCookies)
app.use(VuePlyr, { plyr: {} })

app.mixin(titleMixin)
app.use(install)

app.config.globalProperties.$uuid = {v1: uuidv1, v4: uuidv4}

app.mount('#app')
